<template>
    <div class="mktops-track-page" >
        <md-content class="no-bg md-scrollbar">
            <div class="main-track">
                <div class="pageTitle">
                    TRACK MY CAMPAIGN
                </div>
                <md-card class="card-content">
                    <div class="header">
                        <div class="header-label">
                            <label class="card-title">PERFORMANCE VIEW</label>
                        </div>
                        <div class="head-option">
                            <div class="head-option-box">
                                <div class="graph-label green">Tier 1</div>
                                <div class="graph-label sky" >Tier 2</div>
                                <div class="graph-label blue" >Tier 3</div>
                                <div class="graph-label violet" >Tier 4</div>
                                <div class="mktops-cmp-select-view">
                                    <md-field class="cmp-box">
                                        <md-select class="fnt-12" v-model="selectedOption">
                                            <md-option value="Best Value">Best Value</md-option>
                                        </md-select>
                                    </md-field>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="content">
                        <div class="content-graph">
                            <chart :options="option"></chart> 
                        </div>
                    </div>
                </md-card>
                <md-card class="card-content">
                    <div class="content">
                        <div class="content-table">
                            
                            <div class="main-content-header">
                                <div class="content-label">
                                    <label class="content-label-text">LIST OF PROMOTIONS SORTED BY</label>
                                </div>
                                <div class="content-label-tool" >
                                    <div class="mktops-search-text-align">
                                        <div class="mktops-cmp-select-view">
                                            <md-field class="cmp-box">
                                                <md-select v-model="performance">
                                                    <md-option value="Best Performing">Best Performing</md-option>
                                                </md-select>
                                            </md-field>
                                        </div>
                                        <div class="mktops-select-view">
                                            <md-field class="md-search-box">
                                                <i class="md-icon material-icons">search</i> 
                                                <md-input type="text" v-model="search" @input="searchItems(search)" placeholder="Search my campaign..."></md-input>
                                            </md-field>
                                        </div>
                                    </div>
                                    <div class="mktops-select-text-align">
                                        <div class="mktops-cmp-select-view">
                                            <md-field class="cmp-box">
                                                <md-select v-model="selectedStatus">
                                                    <md-option value="Active">Active</md-option>
                                                </md-select>
                                            </md-field>
                                        </div>
                                        <div class="mktops-select-view">
                                            <md-button class="md-icon-button" @click="showDialogFilter = true">
                                                <md-icon>filter_list</md-icon>
                                            </md-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <md-table>
                                <div>
                                    <md-table-row>
                                        <md-table-head><div style="display:flex;width: 5vmin"></div></md-table-head>
                                        <md-table-head><div style="display:flex;width: 5vmin"></div></md-table-head>
                                        <md-table-head><div style="display:flex;width: 25vmin">Campaign</div></md-table-head>
                                        <md-table-head><div style="display:flex;width: 10vmin">Avg Cost</div></md-table-head>
                                        <md-table-head><div style="display:flex;width: 10vmin">Gross Profit</div></md-table-head>
                                        <md-table-head><div style="display:flex;width: 10vmin">No. Outlets</div></md-table-head>
                                        <md-table-head><div style="display:flex;width: 10vmin">Incremental</div></md-table-head>
                                        <md-table-head><div style="display:flex;width: 10vmin">Past week</div></md-table-head>
                                        <md-table-head><div style="display:flex;width: 10vmin">Total</div></md-table-head>
                                        <md-table-head><div style="display:flex;width: 5vmin"></div></md-table-head>
                                    </md-table-row>
                                </div>
                                <div v-for="(item,index) in filteredList" :key="index">
                                    <md-table-row>
                                        <md-table-head>
                                            <div style="display:flex;width: 5vmin">
                                                <md-button class="md-icon-button" @click="toggleTable(item.sets,index)">
                                                    <md-icon v-if="accordion[index]==false || accordion[index]==undefined">keyboard_arrow_down</md-icon>
                                                    <md-icon v-if="accordion[index]==true">keyboard_arrow_up</md-icon>
                                                </md-button>
                                            </div>
                                        </md-table-head>
                                        <md-table-head>
                                            <div style="display:flex;width: 5vmin">
                                                <div class="mktops-circle-green"></div>
                                            </div>
                                        </md-table-head>
                                        <md-table-head>
                                            <div style="display:flex;width: 25vmin">
                                                <div class="mktops-promo-list-name" style="display:flex;">
                                                    <div class="title-list">{{item.code}}</div>
                                                    &nbsp;
                                                    <div class="subtitle-list">{{item.name}}</div>
                                                </div>
                                            </div>
                                        </md-table-head>
                                        <md-table-head><div style="display:flex;width: 10vmin">{{item.avgCost}}</div></md-table-head>
                                        <md-table-head><div style="display:flex;width: 10vmin">{{showData.gross}}</div></md-table-head>
                                        <md-table-head><div style="display:flex;width: 10vmin">{{item.outlets}}</div></md-table-head>
                                        <md-table-head><div style="display:flex;width: 10vmin">{{showData.incremental}}</div></md-table-head>
                                        <md-table-head><div style="display:flex;width: 10vmin">{{showData.pastweek}}</div></md-table-head>
                                        <md-table-head><div style="display:flex;width: 10vmin">{{showData.total}}</div></md-table-head>
                                        <md-table-head>
                                            <div style="display:flex;width: 5vmin">
                                                <md-button :style="showData.style2" class="md-icon-button">
                                                    <md-icon>more_vert</md-icon>
                                                </md-button>
                                            </div>
                                        </md-table-head>
                                    </md-table-row>
                                    <div v-show="accordion[index] == true">
                                        <md-table-row v-for="(set, sKey) in item.sets" style="padding-left:10vmin" :key="sKey">
                                            <md-table-head>
                                                <div style="display:flex;width: 5vmin">
                                                    <md-button class="md-icon-button"  style="opacity:0;cursor:default">
                                                        <md-icon>keyboard_arrow_down</md-icon>
                                                    </md-button>
                                                </div>
                                            </md-table-head>
                                            <md-table-head>
                                                <div style="display:flex;width: 5vmin">
                                                    <div class="mktops-circle-green"></div>
                                                </div>
                                            </md-table-head>
                                            <md-table-head>
                                                <div style="display:flex;width: 25vmin">
                                                    <div class="mktops-promo-list-name" style="display:flex;">
                                                        <div class="title-list">&nbsp;</div>
                                                        &nbsp;
                                                        <div class="subtitle-list">{{set.setName}}</div>
                                                    </div>
                                                </div>
                                            </md-table-head>
                                            <md-table-head><div style="display:flex;width: 10vmin">{{set.avgSetCost}}</div></md-table-head>
                                            <md-table-head><div style="display:flex;width: 10vmin">{{showData.gross}}</div></md-table-head>
                                            <md-table-head><div style="display:flex;width: 10vmin">{{set.sumSetOutlet}}</div></md-table-head>
                                            <md-table-head><div style="display:flex;width: 10vmin">{{showData.incremental}}</div></md-table-head>
                                            <md-table-head><div style="display:flex;width: 10vmin">{{showData.pastweek}}</div></md-table-head>
                                            <md-table-head><div style="display:flex;width: 10vmin">{{showData.total}}</div></md-table-head>
                                            <md-table-head>
                                                <div style="display:flex;width: 5vmin">
                                                    <md-button :style="showData.style2" class="md-icon-button">
                                                        <md-icon>more_vert</md-icon>
                                                    </md-button>
                                                </div>
                                            </md-table-head>
                                        </md-table-row>
                                    </div>
                                </div>
                                <!-- <md-table-row v-for="set in item.sets" class="panel">
                                    <md-table-head>
										<md-button class="md-icon-button" :style="item.style2">
											<md-icon :style="item.icon">keyboard_arrow_down</md-icon>
											<md-icon :style="item.icon2">keyboard_arrow_up</md-icon>
										</md-button>
                                    </md-table-head>
                                    <md-table-head>
										<div class="mktops-circle-green"></div>
                                    </md-table-head>
                                    <md-table-head>
                                        <div class="mktops-promo-list-name" style="display:flex;">
                                            <div class="title-list">{{item.code}}</div>
                                            &nbsp;
                                            <div class="subtitle-list">{{item.name}}</div>
                                        </div>
                                    </md-table-head>
                                    <md-table-head>{{item.avgCost}}</md-table-head>
                                    <md-table-head>{{showData.gross}}</md-table-head>
                                    <md-table-head>{{item.outlets}}</md-table-head>
                                    <md-table-head>{{showData.incremental}}</md-table-head>
                                    <md-table-head>{{showData.pastweek}}</md-table-head>
                                    <md-table-head>{{showData.total}}</md-table-head>
                                    <md-table-head>
                                        <md-button :style="showData.style2" class="md-icon-button">
                                            <md-icon>more_vert</md-icon>
                                        </md-button>
                                    </md-table-head>
                                </md-table-row> -->
                            </md-table>
                        </div>
                    </div>
                </md-card>
            </div>
        </md-content>
        <md-dialog :md-active.sync="showDialogFilter" class="filter-dialog" id="aaa">
            <md-dialog-title>Add Filters</md-dialog-title>

            <multiselect v-model="selectedFilterProducts"
                id="ajax" 
                label="title_th"
                track-by="title_th" 
                placeholder="Type to search product." 
                open-direction="bottom" 
                :options="dataSearchProducts" 
                :multiple="true" 
                :searchable="true" 
                :loading="isLoading" 
                :internal-search="false" 
                :clear-on-select="false" 
                :close-on-select="false" 
                :options-limit="300" 
                :max-height="600" 
                :show-no-results="true" 
                :hide-selected="true"
                :showLabels="false"
                @search-change="asyncFindProducts"
            >
                <template slot="singleLabel" slot-scope="{ props }">
                    <strong>{{ props.option  }}</strong>
                </template>
                <span slot="noResult">Not found products.</span>
            </multiselect>

            <multiselect v-model="selectedFilterCustomers"
                    id="ajax" 
                    label="title_th"
                    track-by="title_th" 
                    placeholder="Type to search customer." 
                    open-direction="bottom" 
                    :options="dataSearchCustomers" 
                    :multiple="true" 
                    :searchable="true" 
                    :loading="isLoading" 
                    :internal-search="false" 
                    :clear-on-select="false" 
                    :close-on-select="false" 
                    :options-limit="300" 
                    :max-height="600" 
                    :show-no-results="true" 
                    :hide-selected="true"
                    :showLabels="false"
                    @search-change="asyncFindCustomers"
                >
                <template slot="singleLabel" slot-scope="{ props }">
                    <strong>{{ props.option.language  }}</strong>
                </template>
                <span slot="noResult">Not found products.</span>
            </multiselect>

            <md-dialog-actions>
                <md-button @click="showDialogFilter = false" class="md-cancel">cancel</md-button>
                <md-button class="md-primary" @click="addFilter()">add filter</md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import Multiselect from "vue-multiselect";
import Chart from "vue-echarts/components/ECharts";
import CampaignService from "@/services/campaign";
import CoreService from "@/services/core";
import "echarts/lib/chart/scatter";
import "echarts/lib/chart/custom";
import "echarts/lib/component/title";
import "echarts/lib/component/tooltip";
export default {
    name: 'campaign-track',
    beforeCreate(){
        this.$store.dispatch("track/getCampaignList")
    },
    created() {
        // this.showChart()
            this.asyncFindCustomers("")
            this.asyncFindProducts("")
    },
    computed: {
        campaignList() {
            return this.$store.getters['track/campaignList']
		},
    },
    components: {
        Chart,
        Multiselect
    },
    watch:{
        campaignList(){
            if(this.campaignList.length!=0){
                    this.showChart()
            }
        },
    },
  data: () => ({
        selectedOption : "Best Value",
        showData :{
            "gross" : "54.65%",
            "incremental" : "150,000.00 ฿",
            "pastweek" : "200,000.00 ฿",
            "total" : "$1,500,000.00 ฿",
        },
        campaignData: [
            {
            "id": 1,
            "campId" : "111",
            "title": "Back to school [Bangkok]",
            "stDate" : "2018/7/1",
            "lstDate" : "2018/10/30",
            "target" : "150000",
            "avgcost" : "$120.50",
            "gross" : "54.65%",
            "outlets" : "240",
            "incremental" : "$ 150,000.00",
            "pastweek" : "$ 200,000.00",
            "total" : "$ 1,500,000.00",
            "customer" : [
                    {
                        "code" : "00",
                        "title" : "AAA",
                        "sale" : "70000"
                    },
                    {
                        "code" : "01",
                        "title" : "BBB",
                        "sale" : "30000"
                    },
                    {
                        "code" : "02",
                        "title" : "CCC",
                        "sale" : "15000"
                    },
                    {
                        "code" : "03",
                        "title" : "DDD",
                        "sale" : "110000"
                    },
                    {
                        "code" : "04",
                        "title" : "EEE",
                        "sale" : "68000"
                    },
                    {
                        "code" : "05",
                        "title" : "FFF",
                        "sale" : "91000"
                    },
                    {
                        "code" : "06",
                        "title" : "GGG",
                        "sale" : "8000"
                    },
                    {
                        "code" : "07",
                        "title" : "HHH",
                        "sale" : "2500"
                    },
                    {
                        "code" : "08",
                        "title" : "III",
                        "sale" : "8000"
                    },
                    {
                        "code" : "09",
                        "title" : "JJJ",
                        "sale" : "54000"
                    },
                    {
                        "code" : "10",
                        "title" : "KKK",
                        "sale" : "79000"
                    },
                    {
                        "code" : "11",
                        "title" : "LLL",
                        "sale" : "37000"
                    },
                    {
                        "code" : "12",
                        "title" : "MMM",
                        "sale" : "46000"
                    },
                    {
                        "code" : "13",
                        "title" : "NNN",
                        "sale" : "23400"
                    },
                    {
                        "code" : "14",
                        "title" : "OOO",
                        "sale" : "34200"
                    },
                    {
                        "code" : "15",
                        "title" : "PPP",
                        "sale" : "59000"
                    },
                    {
                        "code" : "16",
                        "title" : "QQQ",
                        "sale" : "120000"
                    },
                    {
                        "code" : "17",
                        "title" : "RRR",
                        "sale" : "115000"
                    },
                    {
                        "code" : "18",
                        "title" : "SSS",
                        "sale" : "150000"
                    },
                    {
                        "code" : "19",
                        "title" : "TTT",
                        "sale" : "160000"
                    }
                ]
            },
            {
            "id": 2,
            "campId" : "222",
            "title": "Back to school [Global]",
            "stDate" : "2018/4/1",
            "lstDate" : "2018/10/30",
            "target" : "300000",
            "avgcost" : "$120.50",
            "gross" : "54.65%",
            "outlets" : "60",
            "incremental" : "$ 150,000.00",
            "pastweek" : "$ 200,000.00",
            "total" : "$ 1,500,000.00",
            "customer" : [
                    {
                        "code" : "00",
                        "title" : "AAA",
                        "sale" : "240000"
                    },
                    {
                        "code" : "01",
                        "title" : "BBB",
                        "sale" : "5400"
                    },
                    {
                        "code" : "02",
                        "title" : "CCC",
                        "sale" : "19400"
                    },
                    {
                        "code" : "03",
                        "title" : "DDD",
                        "sale" : "23800"
                    },
                    {
                        "code" : "04",
                        "title" : "EEE",
                        "sale" : "35000"
                    },
                    {
                        "code" : "05",
                        "title" : "FFF",
                        "sale" : "57000"
                    },
                    {
                        "code" : "06",
                        "title" : "GGG",
                        "sale" : "16000"
                    },
                    {
                        "code" : "07",
                        "title" : "HHH",
                        "sale" : "67000"
                    },
                    {
                        "code" : "08",
                        "title" : "III",
                        "sale" : "75000"
                    },
                    {
                        "code" : "09",
                        "title" : "JJJ",
                        "sale" : "84000"
                    },
                    {
                        "code" : "10",
                        "title" : "KKK",
                        "sale" : "98000"
                    },
                    {
                        "code" : "11",
                        "title" : "LLL",
                        "sale" : "160000"
                    },
                    {
                        "code" : "12",
                        "title" : "MMM",
                        "sale" : "99000"
                    },
                    {
                        "code" : "13",
                        "title" : "NNN",
                        "sale" : "37000"
                    },
                    {
                        "code" : "14",
                        "title" : "OOO",
                        "sale" : "61000"
                    },
                    {
                        "code" : "15",
                        "title" : "PPP",
                        "sale" : "48000"
                    }
                ]
            }
        ],
        option : {},
        percentage : [],
        data : [],
        campList : [],
        selectedStatus: "Active",
        performance: "Best Performing",
        search : '',
        filteredList : [],
        extractData : [],
        campData : [],
        series: [],
        colorSets: ['#52B6B0','#527DE5','#5DAAEC','#9A67E3'],
        selectedFilterProducts: [],
        selectedFilterCustomers: [],
        dataSearchProducts: [],
        dataSearchCustomers: [],
        showDialogFilter: false,
        isLoading: false,
        filterCustGroup: "",
        eventsData: [],
        accordion: []
    }),
    methods : {
        toggleTable(set,index){//ย่อขยาย accordion
            if(this.accordion[index] == undefined){
                this.accordion[index] = false;
            }
            this.accordion[index] = !this.accordion[index]
            this.$forceUpdate()
        },
        asyncFindProducts(query) {
            this.isLoading = true;
            CoreService.searchProducts(query).then(response => {
                this.dataSearchProducts = response;
                //console.log(response);
                this.isLoading = false;
            });
        },
        asyncFindCustomers(query) {
            this.isLoading = true;
            CoreService.searchCustomers(query).then(response => {
                this.dataSearchCustomers = response;
                //console.log(response);
                this.isLoading = false;
            });
        },
        searchCampaign(){ //ค้นหา campaign จาก core
            CampaignService.searchCampaigns(this.searchKeyword,this.selectedStatus,this.selectedFilterProducts,this.selectedFilterCustomers).then(response => {
                this.eventsData = [];
                let filteredListTemp = []
                response.forEach(data => {
                    for(let a=0;a<this.filteredList.length;a++){
                        if(this.filteredList[a].code == data.campaign_code){
                            filteredListTemp.push(this.filteredList[a])
                        }
                    }
                    this.eventsData.push({
                        id: data._id,
                        code: data.campaign_code,
                        title: data.campaign_title,
                        start: data.startdate,
                        end: data.enddate,
                        status: data.campaign_status
                    });
                });
                    this.filteredList = filteredListTemp.slice();
            });
        },
        addFilter(){//ฟังก์ชัน filter ตามลูกค้าหรือสินค้า
            this.showDialogFilter = false;
            if(this.selectedFilterCustomers != '' || this.selectedFilterProducts != '' ){
                this.searchCampaign();
            }else{
                this.showChart();
            }
        },
        searchItems(text){//ฟังก์ชันค้นหาชื่อ campaign
            if(text!=''){
                this.filteredList = this.extractData.filter(item => {
                    return item.name.toLowerCase().includes(this.search.toLowerCase()) || item.code.toLowerCase().includes(this.search.toLowerCase())
                })
            }else if(text==''){
                this.filteredList = this.extractData
                return this.filteredList
            }
        },
        showChart(){
            this.extractData = []
            for(let a=0;a<this.campaignList.length;a++){
                let sumcost = 0;
                let sets = [];
                let customer = 0
                let avgCost = 0
                let setAmount = this.campaignList[a].sets.length
                if(this.campaignList[a].campaign_status == 'Active'){ //เช็ค data เอาแต่ data ที่ active
                    for(let b=0;b<this.campaignList[a].sets.length;b++){
                        let reward = this.campaignList[a].sets[b].rewards
                        let customers = this.campaignList[a].sets[b].customers
                        let costTemp = 0;
                        let qtyTemp = 0;
                        for(let c=0;c<reward.length;c++){
                            costTemp = reward[c].cost
                            qtyTemp = reward[c].qty
                        }
                        let customerSet = 0
                        let setcost = 0
                        for(let d=0;d<customers.length;d++){
                            customerSet = customerSet+customers[d].customers.length
                        }
                        setcost = (Number(costTemp)*Number(qtyTemp)) 
                        sumcost = sumcost+(Number(costTemp)*Number(qtyTemp))
                        
                        sets.push({ //ใส่ข้อมูลแต่ละ set
                            "setName" : this.campaignList[a].sets[b].name, //ชื่อ set
                            "sumSetOutlet" : customerSet, //จำนวนร้านค้า
                            "avgSetCost" : setcost/this.campaignList[a].sets.length //ค่าใช้จ่ายเฉลี่ยของ set
                        })
                        customer = customer + customerSet
                    }
                    avgCost = avgCost+sumcost //รวมค่าใช้จ่าย
                    this.extractData.push(
                        {
                            "code" : this.campaignList[a].campaign_code,
                            "name" : this.campaignList[a].campaign_title,
                            "avgCost" : avgCost/setAmount,
                            "outlets" : customer,
                            "sets" : sets
                        }
                    )
                }
            }
            this.filteredList = this.extractData
            let saleList = []
            // ************ แบ่ง data ทุกๆ 5% ************
            for(let a=0;a<this.campaignData.length;a++){
                saleList.push(
                    {
                    0:[],
                    5:[],
                    10:[],
                    15:[],
                    20:[],
                    25:[],
                    30:[],
                    35:[],
                    40:[],
                    45:[],
                    50:[],
                    55:[],
                    60:[],
                    65:[],
                    70:[],
                    75:[],
                    80:[],
                    85:[],
                    90:[],
                    95:[],
                    100:[]
                    }
                )
            }
            
            // ************ คำนวณข้อมูลการซื้อของร้านค้า ************
            for(let a=0;a<this.campaignData.length;a++){
                for(let b=0;b<this.campaignData[a].customer.length;b++){
                    let sale = ((this.campaignData[a].customer[b].sale*100)/this.campaignData[a].target)
                    // sale = Math.ceil(sale/5)*5;
                    sale = Number(sale).toFixed(2);
                    if(sale < 5){
                        saleList[a][0].push(sale)
                    }else if(sale < 10){
                        saleList[a][5].push(sale)
                    }else if(sale < 15){
                        saleList[a][10].push(sale)
                    }else if(sale < 20){
                        saleList[a][15].push(sale)
                    }else if(sale < 25){
                        saleList[a][20].push(sale)
                    }else if(sale < 30){
                        saleList[a][25].push(sale)
                    }else if(sale < 35){
                        saleList[a][30].push(sale)
                    }else if(sale < 40){
                        saleList[a][35].push(sale)
                    }else if(sale < 45){
                        saleList[a][40].push(sale)
                    }else if(sale < 50){
                        saleList[a][45].push(sale)
                    }else if(sale < 55){
                        saleList[a][50].push(sale)
                    }else if(sale < 60){
                        saleList[a][55].push(sale)
                    }else if(sale < 65){
                        saleList[a][60].push(sale)
                    }else if(sale < 70){
                        saleList[a][65].push(sale)
                    }else if(sale < 75){
                        saleList[a][70].push(sale)
                    }else if(sale < 80){
                        saleList[a][75].push(sale)
                    }else if(sale < 85){
                        saleList[a][80].push(sale)
                    }else if(sale < 90){
                        saleList[a][85].push(sale)
                    }else if(sale < 95){
                        saleList[a][90].push(sale)
                    }else if(sale < 100){
                        saleList[a][95].push(sale)
                    }else if(sale == 100 || sale > 100){
                        saleList[a][100].push(sale)
                    }
                }
            }
            // ************ จบการคำนวณข้อมูลการซื้อของร้านค้า ************
            
            // ************ กำหนด data ตาม campaign ************
            for(let a=0;a<this.campaignData.length;a++){
                for(let b=0;b<=100;b++){
                    if(b%5==0){
                        // this.data.push([a,b,saleList[a][b].length]);
                        if(this.campList[a] == undefined){
                            this.campList[a] = []
                        }
                        this.campList[a].push([b,a,saleList[a][b].length,this.campaignData[a].campId,this.campaignData[a].title,this.campaignData[a].outlets])
                    }
                }
            }
            // ************ จบการกำหนด data ตาม campaign ************
        // ************ จบการแบ่ง data ตาม % ************

            // ************ คำนวณวันที่ปัจจุบันว่าเป็นกี่ % ของ campaign ************
            let dateResult = []
            let CurrentDate = new Date();
            let line = []
            for(let a=0;a<this.campaignData.length;a++){
                let oneDay = 24*60*60*1000;
                let endDate = new Date(this.campaignData[a].lstDate)
                let startDate = new Date(this.campaignData[a].stDate)
                let dateRange = Math.round(Math.abs((startDate.getTime() - endDate.getTime())/(oneDay)));
                let nowRange = Math.round(Math.abs((startDate.getTime() - CurrentDate.getTime())/(oneDay)));
                dateResult.push(Math.round((nowRange*100)/dateRange))
            }
            // ************ จบคำนวณวันที่ปัจจุบันว่าเป็นกี่ % ของ campaign ************
            for(let a=0;a<this.campaignData.length;a++){
                line.push({
                        value: [dateResult[a],a],
                        itemStyle: {
                            normal: {
                                color: "#ff0000"
                            }
                        }
                    })
                    this.campData.push(this.campaignData[a].title)
                    
            }
            
            // ************ สร้าง % บนกราฟ ************
            for(let a=0;a<=100;a++){
                this.percentage.push(a)
            }
            // ************ จบสร้าง % บนกราฟ ************

            // ************ กำหนด option ของข้อมูลการพล็อต ************
            this.data = this.campList
                for(let a=0;a<this.data.length;a++){
                    this.series[a] = {
                                        name: 'Punch Card',
                                        type: 'scatter',
                                        symbolSize: function (dataItem) {
                                            return dataItem[1] * 4;
                                        },
                                        itemStyle: {
                                            color: this.colorSets[a]
                                        },
                                        data: this.data[a]
                                    }
                                    , {
                                        type: 'custom',
                                        itemStyle: {
                                            color: "#FF0000",
                                            opacity : 0.6,
                                            normal: {
                                                borderWidth: 1.5
                                            }
                                        },
                                        data: line,
                                        z: 100
                                    }
            }
            // ************ จบการกำหนด option ของข้อมูลการพล็อต ************
            // ************ กำหนด option ให้ graph ************
            this.option = {
                
                // ************ tooltip เวลาเอาเมาส์ไปชี้จุดบน graph ************
                tooltip: {
                    position: 'top',
                    formatter: function(params) {
                        var tooltip =
                            '<span class="xxxx">' + params.value[3] + "</span><br />";
                        tooltip +=
                            '<p class="graph-tooltips-head">' + params.value[4] + "</p>";
                        // tooltip +=
                        //     '<p class="graph-tooltips-label">Sales <span class="graph-tooltips-text">$' +
                        //     params.value[0] +
                        //     "</span></p>";
                        tooltip +=
                            '<p class="graph-tooltips-label" style="color:blue">Outlets <span class="graph-tooltips-text" style="color:black">' +
                            params.value[5] +
                            "</span></p>";
                        // tooltip += '<p class="graph-tooltips-label">Incremental <span class="graph-tooltips-text">$'+params.value[1]+"</span></p>";
                        tooltip +=
                            '<p class="graph-tooltips-label" style="color:blue">Progress <span class="graph-tooltips-text" style="color:black">' +
                            params.value[0] +
                            "%</span></p>";
                        return tooltip;
                    },
                    backgroundColor: "rgba(255,255,255,1)",
                    textStyle: {
                        color: "#000"
                    },
                    extraCssText: "box-shadow: 0 2px 5px 2px rgba(0, 0, 0, 0.1); padding:14px"
                },
                // ************ จบ tooltip เวลาเอาเมาส์ไปชี้จุดบน graph ************
                
                // ************ กำหนดตำแหน่งของ graph ************
                grid: {
                    left: 40,
                    bottom: 50,
                    right: 40,
                    containLabel: true,
                    height: 150
                },
                // ************ จบการกำหนดตำแหน่งของ graph ************
                // ************ กำหนดค่าของแกน x ************
                xAxis: [{
                    name: "CAMPAIGN COMPLETION",
                    nameLocation: "middle",
                    nameTextStyle: {
                        color: "#727272",
                        fontWeight: "bold",
                        fontSize: "16",
                        fontFamily: "roboto",
                        padding: [20, 0, 0, 0]
                    },
                    type: 'value',
                    data: this.percentage,
                    boundaryGap: false,
                    splitLine: {
                        show: false
                    },
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        formatter: function (value) {
                            return value+"%"
                        }
                    },
                    splitNumber: 10
                },
                {
                    show: false,
                    type: 'category',
                    data: this.percentage,
                    splitLine: {
                        show: false
                    },
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        interval: function(value){
                            if(value%10 == 0){
                                return value
                            }
                        },
                        formatter: function (value) {
                            return value+"%"
                        }
                    }
                }
                ],
                // ************ จบการกำหนดค่าของแกน x ************
                // ************ กำหนดค่าของแกน y ************
                yAxis: [{
                    type: 'category',
                    data: this.campData,
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                }
                ],
                // ************ จบการกำหนดค่าของแกน y ************
                // ************ กำหนดชนิดของกราฟและข้อมูลการพล็อต ************
                series: [{
                    type: 'scatter',
                    symbolSize: function (val,a,b) {
                        return val[2]*5;
                    },
                    itemStyle: {
                        color: '#52B6B0'
                    },
                    data: this.data[0],
                    animationDelay: function (idx) {
                        return idx * 5;
                    }
                }
                , {
                    type: 'custom',
                    itemStyle: {
                        color: "#FF0000",
                        opacity : 0.6,
                        normal: {
                            borderWidth: 1.5
                        }
                    },
                // ************ จบการกำหนดชนิดของกราฟและข้อมูลการพล็อต ************
                    renderItem:function(params, api){
                        var xValue = api.value(0);
                        var highPoint = api.coord([xValue, api.value(1)]);
                        var lowPoint = api.coord([xValue, api.value(2)]);
                        var halfWidth = api.size([1, 0])[0] * 0.1;
                        var style = api.style({
                            stroke: api.visual('color'),
                            fill: null
                        });

                        return {
                            type: 'group',
                            children: [{
                                type: 'line',
                                shape: {
                                    x1: highPoint[0], y1: highPoint[1]+20,
                                    x2: highPoint[0], y2: highPoint[1]-20
                                },
                                style: style
                            }]
                        };
                    },
                    data: line,
                    z: 100
                },{
                    type: 'scatter',
                    symbolSize: function (val,a,b) {
                        return val[2]*5;
                    },
                    itemStyle: {
                        color: '#527DE5'
                    },
                    data: this.data[1],
                    animationDelay: function (idx) {
                        return idx * 5;
                    }
                }
                , {
                    type: 'custom',
                    itemStyle: {
                        color: "#FF0000",
                        opacity : 0.6,
                        normal: {
                            borderWidth: 1.5
                        }
                    },
                    renderItem:function(params, api){
                        var xValue = api.value(0);
                        var highPoint = api.coord([xValue, api.value(1)]);
                        var lowPoint = api.coord([xValue, api.value(2)]);
                        var halfWidth = api.size([1, 0])[0] * 0.1;
                        var style = api.style({
                            stroke: api.visual('color'),
                            fill: null
                        });

                        return {
                            type: 'group',
                            children: [{
                                type: 'line',
                                shape: {
                                    x1: highPoint[0], y1: highPoint[1]+20,
                                    x2: highPoint[0], y2: highPoint[1]-20
                                },
                                style: style
                            }]
                        };
                    },
                    data: line,
                    z: 100
                },{
                    type: 'scatter',
                    symbolSize: function (val,a,b) {
                        return val[2]*5;
                    },
                    itemStyle: {
                        color: '#527DE5'
                    },
                    data: this.data[2],
                    animationDelay: function (idx) {
                        return idx * 5;
                    }
                }
                , {
                    type: 'custom',
                    itemStyle: {
                        color: "#FF0000",
                        opacity : 0.6,
                        normal: {
                            borderWidth: 1.5
                        }
                    },
                    renderItem:function(params, api){
                        var xValue = api.value(0);
                        var highPoint = api.coord([xValue, api.value(1)]);
                        var lowPoint = api.coord([xValue, api.value(2)]);
                        var halfWidth = api.size([1, 0])[0] * 0.1;
                        var style = api.style({
                            stroke: api.visual('color'),
                            fill: null
                        });

                        return {
                            type: 'group',
                            children: [{
                                type: 'line',
                                shape: {
                                    x1: highPoint[0], y1: highPoint[1]+20,
                                    x2: highPoint[0], y2: highPoint[1]-20
                                },
                                style: style
                            }]
                        };
                    },
                    data: line,
                    z: 100
                },{
                    type: 'scatter',
                    symbolSize: function (val,a,b) {
                        return val[2]*5;
                    },
                    itemStyle: {
                        color: '#527DE5'
                    },
                    data: this.data[3],
                    animationDelay: function (idx) {
                        return idx * 5;
                    }
                }
                // ************ function สร้างขีดสรแดงบน graph ************
                , {
                    type: 'custom',
                    itemStyle: {
                        color: "#FF0000",
                        opacity : 0.6,
                        normal: {
                            borderWidth: 1.5
                        }
                    },
                    
                    renderItem:function(params, api){
                        var xValue = api.value(0);
                        var highPoint = api.coord([xValue, api.value(1)]);
                        var lowPoint = api.coord([xValue, api.value(2)]);
                        var halfWidth = api.size([1, 0])[0] * 0.1;
                        var style = api.style({
                            stroke: api.visual('color'),
                            fill: null
                        });

                        return {
                            type: 'group',
                            children: [{
                                type: 'line',
                                shape: {
                                    x1: highPoint[0], y1: highPoint[1]+20,
                                    x2: highPoint[0], y2: highPoint[1]-20
                                },
                                style: style
                            }]
                        };
                    },
                    data: line,
                    z: 100
                }
                // ************ จบ function สร้างขีดสรแดงบน graph ************
                ]
            };
            // ************ จบการกำหนด option ให้ graph ************
        }
    },
}
</script>
<style lang="scss">
.md-table-head{

    .md-table-head-container{
        color: #414141;

        .md-table-head-label{
            height : auto;
        }

    }

}

    .mktops-cmp-select-view{
        display: inline-block;
        .md-field:after,
        .md-field:before {
            left: unset;
        }

        .cmp-box{
            width: 150px;
            padding: 10px 11px;
            margin: 4px 0 0;

            .md-menu.md-select{
                background-color: #efefef;
                border-radius: 3px;
                overflow: hidden;
                height: 28px;

                .md-input.md-input.md-select-value{
                    font-size: 12px;
                    padding-left: 10px;
                }

            }

        }

    }
    
    .content-table{

        .md-card.md-table.md-table-list.md-theme-default{
            box-shadow: unset;
            padding-right: 8px;
            font-size: 12px;
            font-family: Roboto;
            height: 400px;

            .md-table-fixed-header.md-table-fixed-header-active{
                border-bottom-color : white !important;
            }
            
        }
    }

    #track-accordion{
        .component-badger-accordion.badger-accordion--initalised{
            .badger-accordion-item{
                .badger-accordion__header{
                    .js-badger-accordion-header{
                        .badger-accordion-toggle{
                            flex: 0 0 100%;
                        }
                        .badger-toggle-indicator{
                            display: none;
                        }
                    }
                }
            }
        }
    }    
    // #aaa{
    //     .md-dialog-container{
    //         .filter-dialog{
    //             margin : 10px 20px 0 10px !important;
    //         }
    //     }
    // }
</style>
<style lang="scss" scoped>
    // .md-dialog.filter-dialog.md-dialog-fullscreen.md-theme-default{
    //     .md-dialog-container{
    //                 color:red;
    //                 background-color:
    //         .filter-dialog{
    //         }
    //     }
    // }


        // .md-dialog.filter-dialog.md-dialog-fullscreen.md-theme-default .md-dialog-container{
        // }
    
    .multiselect{
        margin: 10px 20px 0 10px !important;
    }
    .mktops-circle-green {
      width: 36px;
      height: 36px;
      background-color: #52B6B0;
      border-radius: 40px;
      line-height: 36px;
      text-align: center;
      font-size: 10px;
      color: #ffffff;
    }
    .no-bg{
        background-color: unset;
    }
    .md-list-item-text{
    }

    .mktops-track-page{
        background-color:#F6F9FC;
        .main-track{
            height: calc(92vmin);
            overflow-y: auto;
            .pageTitle{
                color: #797979;
                font-size: 2.4vmin;
                font-weight: 900;
                font-family: Lato;
                margin-left: 30px;
                margin-right: 30px; 
                margin-top: 24px;
                margin-bottom: 19px;
            }

            .card-content{
                margin-left: 30px;
                margin-right: 30px; 
                margin-bottom: 30px;
                margin-top: 10px;

                .header{
                    padding: 15px 30px 0 30px;
                    display: flex;
                    // margin-top : 20px;
                    // margin-left : 20px;
                    // margin-right : 20px;
                    // margin-bottom : 5px;

                    .header-label{
                        padding-top: 20px;
                        padding-bottom: 10px;
                        width: 30%;

                        .card-title{
                            font-weight: bold;
                            width: 30%;
                            padding-top: 30px;
                            font-size: 16px;
                        }

                    }
                    
                    .head-option{
                        width: 70%;
                        display:flex;
                        justify-content: flex-end;
                        
                        .head-option-box{
                            // width: 16%; 
                            width: 67%;
                            display: inherit;
                            
                            .graph-label{
                                width: 13vmin;
                                height: 26px;
                                // margin: 0 4px 0 0;
                                border-radius: 4px;
                                font-size: 10px;
                                font-weight: bold;
                                color: #ffffff;
                                text-align: center;
                                line-height: 26px;
                                cursor: default;
                                margin: auto 1vmin auto 1vmin;
                                overflow: hidden;
                                float: right;
                                
                                &.green{
                                    background-color:#52B6B0;
                                }

                                &.blue{
                                    background-color:#527DE5;
                                }

                                &.sky{
                                    background-color:#5DAAEC;
                                }

                                &.violet{
                                    background-color:#9A67E3;
                                }
                                
                            }
                            
                            .mktops-select-view{
                                
                                .md-field.box > .md-input.md-select-value,
                                .md-field.box > .md-menu.md-select {
                                    height: 28px;
                                    width: 200px;
                                }


                                .md-field.md-field.box {
                                    padding: 10px 11px;
                                    margin: 4px 0 0;
                                    padding: 10px 11px;
                                    margin: 4px 0 0;
                                }

                                .md-field:after,
                                .md-field:before {
                                    left: unset;
                                }

                                .md-field.box > .md-menu.md-select {
                                    overflow: hidden;
                                    width: 131px;
                                    
                                .md-input .md-input .md-select-value{
                                        font-size: 12px !important;
                                        padding-left: 12px;
                                    }

                                }

                                .md-field.box .md-select {
                                    background-color: #efefef;
                                    border-radius: 3px;
                                }

                                // .md-input .md-input .md-select-value{
                                //     font-size: 12px;
                                //     padding-left: 12px;
                                // }
                            }

                        }

                    }

                }

                .content{
                    .content-graph{
                        .echarts {
                            height: 40vh !important;
                            width: 100% !important;
                            background-color: #F8F8F8;
                            padding-top: 20px;
                            margin-top: 15px;

                        }
                    }

                    .content-table{

                        .main-content-header{
                            display: block;
                            padding: 15px 30px 0 30px;
                            
                            .content-label{
                                display: inline-block;
                                width: 25%;

                                .content-label-text{
                                    font-family: roboto;
                                    font-size: 16px;
                                    font-weight: bold;
                                    text-transform: uppercase;
                                }

                            }

                            .content-label-tool{
                                display: inline-block;
                                width: 75%;

                                .mktops-search-text-align{
                                    display: inline-block;
                                    width: 65%;
                                    // .mktops-select-view{
                                    //     display:inline-block;
                                    // }
                                }
                                .mktops-select-text-align{
                                    display: inline-block;
                                    width: 35%;
                                    text-align: right;
                                }

                                .mktops-select-view{
                                    display: inline-block;
                                    vertical-align: middle;

                                    .md-search-box{
                                        margin: 16px 20px 15px 11px;
                                        padding-top: unset;
                                        border-radius: 3px;
                                        min-height: 20px;
                                        width: 30vmin;
                                        overflow: hidden;
                                        -webkit-box-shadow: 0 0 3px rgba(0, 0, 0, 0.16), 0 0 0 transparent, 0 1px 1px -2px transparent;
                                        box-shadow: 0 0 3px rgba(0, 0, 0, 0.16), 0 0 0 transparent, 0 1px 1px -2px transparent;

                                        .md-icon.material-icons{
                                            margin-left: 17px;
                                            color: rgba(0, 0, 0, 0.54);
                                        }

                                    }

                                    .md-field.box > .md-input.md-select-value,
                                    .md-field.box > .md-menu.md-select {
                                        height: 28px;
                                        width: 200px;
                                    }


                                    .md-field.md-field.box {
                                        padding: 10px 11px;
                                        margin: 4px 0 0;
                                        padding: 10px 11px;
                                        margin: 4px 0 0;
                                    }

                                    .md-field:after,
                                    .md-field:before {
                                        left: unset;
                                    }

                                    .md-field.box > .md-menu.md-select {
                                        overflow: hidden;
                                        width: 131px;
                                        
                                    .md-input .md-input .md-select-value{
                                            font-size: 12px !important;
                                            padding-left: 12px;
                                        }

                                    }

                                    .md-field.box .md-select {
                                        background-color: #efefef;
                                        border-radius: 3px;
                                    }

                                }

                            }

                        }

                        .md-table-row{
                            .md-table-head{
                                font-size: 12px !important;
                            }

                            .md-table-cell{
                                border: 0px;
                                font-size: 12px !important;
                            }

                            #icon{
                                .md-table-cell-container{
                                    padding: 0 !important;
                                }

                            }
                        }
                    }

                }

            }
        
        }
    }
</style>